import { useState, useEffect } from "react"

import Start from "./Backgrounds/1/Start"
import SelectRole from "./Backgrounds/2/SelectRole"
import TheGame from "./Backgrounds/3/TheGame"
import AristotleQuote from "./Backgrounds/4/AristotleQuote"
import RingRingScreen from "./Backgrounds/5/RingRingScreen"
import Instructions from "./Backgrounds/6/Instructions"
import Oops from "./Backgrounds/Default/Oops"

const Navigation = ({setAllowScroll, overRide, setOverRide}) => {
    const [navi, setNavi] = useState(1)

    useEffect(() => {
        if(overRide) {
            setNavi(2)
            setOverRide(false)
        }
    }, [overRide])

    const nextPage = () => {
        setAllowScroll(false)
        setNavi(navi + 1)
    }

    const backToSelectRole = () => {
        setAllowScroll(false)
        setNavi(2) //kuuluu mennä instructioniin
    }

    switch (navi) {
        case 1:
            return <Start setPage={setNavi} nextPage={nextPage} />
        case 2:
            return <Instructions setPage={setNavi} nextPage={nextPage} setAllowScroll={setAllowScroll} />
        case 3:
            return <SelectRole setPage={setNavi} nextPage={nextPage} />
        case 4:
            return <AristotleQuote nextPage={nextPage} />
        case 5:
            return <RingRingScreen nextPage={nextPage} backToSelectRole={backToSelectRole}/>
        case 6:
            return <TheGame setPage={setNavi} nextPage={nextPage} />
        default:
            return <Oops setPage={setNavi} nextPage={nextPage} />
    }
}

export default Navigation